export const LOCATION_ID_PREFIX = "location-";

export function getLocationIdFromSelectedId(selectedId?: string) {
  return selectedId?.startsWith(LOCATION_ID_PREFIX)
    ? Number(selectedId?.replace(LOCATION_ID_PREFIX, ""))
    : undefined;
}
